import CustomHighlight from './CustomHighlight.vue';
import messages from './i18n/index';
import {
    HIGHLIGHT_COLORS, fulFillHighlightListModel, isAllDisabled, isAllEmpty, ChangeTypes,
} from './nexus.ts';
import ScrollToHighlightHelper from './ScrollToHighlightHelper.ts';

export {
    messages,
    ScrollToHighlightHelper,
    HIGHLIGHT_COLORS, fulFillHighlightListModel, isAllDisabled, isAllEmpty, ChangeTypes,
};
export default CustomHighlight;
